import React, { Component, Fragment } from 'react'
import moment from 'moment'
import _ from 'lodash'
import { Page } from './styled'
import { Field } from '../../../../../styles'
import {
  DatePicker,
  PrivacySelector,
  OrganizationPicker,
  GroupPicker
} from './components'
import { Input, Checkbox, Button, Spin, message, Modal, Col, Form } from 'antd'
import history from '../../../../../history'
import { withTranslation, Trans } from 'react-i18next'
import { general } from '../../../../../constants'
import { api } from '../../../../../services'
import ReactSVG from 'react-svg'
import './styles.scss'
import Description from './components/Description/Description'
import ReminderTriggers from './components/ReminderTriggers/ReminderTriggers'

class PublishSettings extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedType: [0],
      startValue: moment(),
      is_mandatory: false,
      is_retried: false,
      is_recurrence: false,
      mandatory_reminder: null,
      quiz_retried_reminder: null,
      recurrence_reminder: null,
      endValue: null,
      selectedOrganizations: [],
      selectedGroups: [],
      emails: [],
      isEmailsValid: false,
      checkedTerms: false,
      isAdminOnly: false,
      isDisable: true,
      isPublish: false,
      isSendMail: false,
      isCheckModal: false,
      isNotExist: [],
      isNotInOrg: [],
      enableMarketplace: false,
      isPublishing: false
    }
    this.handleInsertUsers = _.debounce(this.handleInsertUsers, 1000)
    this.handleCheckUser = _.debounce(this.handleCheckUser, 500)
  }

  async componentDidMount() {
    const {
      courseBuilder: {
        courseExpDate,
        courseStartDate,
        CourseIsMandatory,
        CourseIsRetried,
        CourseIsRecurrence,
        courseReminders
      },
      get,
      courses: { courseById }
    } = this.props
    const normalized = await Promise.resolve(
      this.normalizeReminders(courseReminders)
    )
    this.setState(
      {
        startValue: courseStartDate && moment(courseStartDate),
        endValue: courseExpDate && moment(courseExpDate),
        is_mandatory: CourseIsMandatory,
        is_recurrence: CourseIsRecurrence,
        is_retried: CourseIsRetried,
        mandatory_reminder: normalized.mandatory_reminder,
        recurrence_reminder: normalized.recurrence_reminder,
        quiz_retried_reminder: normalized.quiz_retried_reminder
      },
      () => {
        this.getOldSetting(courseById)
      }
    )
    if (get) {
      get()
    }
  }
  normalizeReminders = reminders => {
    const normalized = {
      mandatory_reminder: null,
      recurrence_reminder: null,
      quiz_retried_reminder: null
    }

    reminders.forEach(r => {
      const data = {
        interval: r.interval || undefined,
        interval_count: r.interval_count || undefined,
        due_date: moment(r.due_date) || undefined
      }

      if (r.type === 'mandatory') {
        normalized.mandatory_reminder = data
      } else if (r.type === 'recurrence') {
        normalized.recurrence_reminder = data
      } else if (r.type === 'quiz_retry') {
        normalized.quiz_retried_reminder = data
      }
    })

    return normalized
  }
  async componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props) {
      console.log('updateworkedforsettings :>> ')
      this.checkEnableMarketPlace()
      const {
        courseBuilder: {
          courseExpDate,
          courseStartDate,
          CourseIsMandatory,
          CourseIsRetried,
          CourseIsRecurrence,
          courseReminders
        },
        courses: { courseById }
      } = this.props
      if (
        courseStartDate !== prevProps.courseBuilder.courseStartDate &&
        courseStartDate
      ) {
        this.setState(
          {
            startValue: moment(courseStartDate),
            endValue: courseExpDate && moment(courseExpDate)
          },
          () => {
            this.getOldSetting(courseById)
          }
        )
      }
      try {
        const normalized = await Promise.resolve(
          this.normalizeReminders(courseReminders)
        )
        if (normalized) {
          this.setState(
            {
              is_mandatory: CourseIsMandatory,
              is_recurrence: CourseIsRecurrence,
              is_retried: CourseIsRetried,
              mandatory_reminder: normalized.mandatory_reminder,
              recurrence_reminder: normalized.recurrence_reminder,
              quiz_retried_reminder: normalized.quiz_retried_reminder
            },
            () => {
              this.getOldSetting(courseById)
            }
          )
        }
      } catch (error) {}
    }
  }

  checkEnableMarketPlace = () => {
    const {
      courseBuilder: {
        courseId,
        courseTitle,
        courseImg,
        courseOrganiser,
        courseCategory,
        courseIsFree,
        courseMarketPlaceDescription,
        courseNoOfLessons,
        courseNoOfVideos,
        courseObjectives,
        // courseOrganization,
        courseOutline,
        coursePrice,
        // courseGroup,
        courseVideoLink
      }
    } = this.props
    let data = {
      courseId,
      courseTitle,
      courseImgId: courseImg.id,
      courseOrganiser,
      courseCategory,
      courseIsFree,
      courseMarketPlaceDescription,
      courseNoOfVideos,
      courseObjectives,
      // courseOrganization,
      courseOutline,
      courseNoOfLessons,
      ...(!courseIsFree && { coursePrice }),
      // courseGroup,
      courseVideoLink
    }
    let errorData = Object.keys(data).filter(k => {
      return data[k] === '' || data[k] === undefined || data[k] === null
    })

    console.log('errorData :>> ', errorData)

    if (errorData.length === 0) {
      this.setState({
        enableMarketplace: true
      })
    }
  }

  getOldSetting = courseById => {
    const {
      item: { setting }
    } = courseById
    if (setting) {
      const {
        group_ids,
        publish_option,
        organization_ids,
        emails,
        is_admin_only: isAdminOnly
      } = setting

      if (publish_option === general.ORGANIZATION_AND_MARKETPLACE) {
        this.setState({ selectedType: [2, 5] })
      } else if (publish_option === general.ORGANIZATION) {
        this.handleSelectedType(2)
      } else if (publish_option === general.ORGANIZATION_GROUP) {
        this.handleSelectedType(3)
      } else if (publish_option === general.SPECIFIC_USER) {
        this.handleSelectedType(4)
      } else if (publish_option === general.PUBLIC) {
        this.handleSelectedType(1)
      } else if (publish_option === general.MARKETPLACE) {
        this.handleSelectedType(5)
      }
      this.handleInsertUsers(_.uniq(emails).join('\n'))
      this.setState({
        selectedOrganizations: organization_ids,
        selectedGroups: group_ids,
        emails,
        isAdminOnly
      })
    }
  }

  getLastOption = () => {
    if (this.checkSelectedType(2) && this.checkSelectedType(5)) {
      return general.ORGANIZATION_AND_MARKETPLACE
    } else if (this.checkSelectedType(1)) {
      return general.PUBLIC
    } else if (this.checkSelectedType(2)) {
      return general.ORGANIZATION
    } else if (this.checkSelectedType(3)) {
      return general.ORGANIZATION_GROUP
    } else if (this.checkSelectedType(5)) {
      return general.MARKETPLACE
    } else {
      return general.SPECIFIC_USER
    }
  }

  checkSelectedType = id => this.state.selectedType.some(item => item === id)

  handlePublish = () => {
    const {
      courseBuilder: {
        courseId,
        courseTitle,
        courseDescription,
        courseImg,
        courseTags,
        courseOrganiser,
        courseCategory,
        courseIsFree,
        courseMarketPlaceDescription,
        courseNoOfLessons,
        courseNoOfVideos,
        courseObjectives,
        // courseOrganization,
        courseOutline,
        coursePrice,
        courseLang,
        courseVideoLink,
        coursePassScore,
        courseBadgeId,
        courseCertId,
        courseEmails,
        courseShareProfile,
        coursePriceToEdit,
        courseEditPermission
      },
      update,
      t,
      user: {
        info: { username, bio, linkedin }
      },
      resetCourseById
    } = this.props

    const {
      selectedOrganizations,
      selectedGroups,
      emails,
      isEmailsValid,
      startValue,
      endValue,
      isAdminOnly: is_admin_only,
      isSendMail,
      is_mandatory,
      is_retried,
      is_recurrence,
      mandatory_reminder,
      quiz_retried_reminder,
      recurrence_reminder
    } = this.state

    const removedSpaceEmail = _.map(emails, email => email.trim().toLowerCase())

    let privacy = {
      is_public: this.checkSelectedType(1),
      is_admin_only: this.checkSelectedType(1) ? is_admin_only : false,
      organization_ids: selectedOrganizations,
      group_ids: selectedGroups,
      emails: _.uniq([...removedSpaceEmail]),
      publish_option: this.getLastOption(),
      is_marketplace: this.checkSelectedType(5)
    }

    console.log('cloprivacy', privacy)

    const data = {
      title: courseTitle,
      description: courseDescription,
      organiser: courseOrganiser,
      topics: courseTags,
      cover_id: courseImg.id,
      start_date: startValue,
      pass_score: coursePassScore,
      exp_date: endValue,
      cert_id: courseCertId,
      badge_id: courseBadgeId,
      lang: courseLang,
      ...(courseCategory && {
        marketplace: {
          course_id: courseId,
          username: username,
          category_id: courseCategory,
          is_free: courseIsFree,
          price: coursePrice,
          video_link: courseVideoLink,
          no_of_video: courseNoOfVideos,
          no_of_lesson: Number(courseNoOfLessons),
          course_obj: courseObjectives,
          course_outline: courseOutline,
          course_description: courseMarketPlaceDescription,
          is_shared_profile: courseShareProfile,
          price1: !coursePriceToEdit ? 1 : coursePriceToEdit,
          edit_permission: courseEditPermission,
          bio,
          linkedin
        }
      }),
      isSendMail,
      privacy,
      host_emails: courseEmails,
      is_mandatory: is_mandatory,
      is_retried: is_retried,
      is_recurrence: is_recurrence,
      mandatory_reminder: mandatory_reminder,
      quiz_retried_reminder: quiz_retried_reminder,
      recurrence_reminder: recurrence_reminder
    }

    console.log('clopublishdata :>> ', data)

    if (!startValue) {
      message.error(t('dates_validation_error'))
      return
    }

    if (!_.isEmpty(emails) && !isEmailsValid) {
      message.error(t('emails_validation_error'))
      return
    }

    if (update) {
      this.setState(
        {
          isPublishing: true
        },
        async () => {
          await this.processIndexing()

          update(data, courseId)
            .then(() => {
              resetCourseById()
              history.push('/courses/' + courseId)
            })
            .catch(err => {
              this.setState({
                isPublishing: false
              })

              message.error(err.message)
            })
        }
      )
    }
  }

  processIndexing = async () => {
    const {
      courseBuilder: { courseId }
    } = this.props

    await api.courses
      .processLessonForIndexing({
        course_id: courseId
      })
      .catch(err => {
        console.log(err)
      })
  }

  handleSelectedDate = (field, value) => {
    this.setState({
      [field]: value
    })
  }

  handleSelectedType = id => {
    const { selectedType } = this.state

    // selectedType changed to array to add the usecase of multiple select of marketplace and organization in publish settings

    if (
      id === 1 ||
      id === 3 ||
      id === 4 ||
      selectedType[0] === 1 ||
      selectedType[0] === 3 ||
      selectedType[0] === 4
    ) {
      this.setState({
        selectedType: [id]
      })
    } else if (selectedType.some(i => i === id)) {
      this.setState({
        selectedType:
          selectedType.length === 1
            ? [id]
            : selectedType.filter(item => item !== id)
      })
    } else {
      this.setState({
        selectedType: [...selectedType, id]
      })
    }
  }

  handleSelectedOrganizations = id => {
    const { selectedOrganizations } = this.state

    if (selectedOrganizations.includes(id)) {
      this.setState({
        selectedOrganizations: selectedOrganizations.filter(
          organizationId => organizationId !== id
        )
      })
    } else {
      this.setState({
        selectedOrganizations: [...selectedOrganizations, id]
      })
    }
  }

  handleSelectedGroups = groupId => {
    const { selectedGroups } = this.state

    this.setState({
      selectedGroups: selectedGroups.includes(groupId)
        ? selectedGroups.filter(i => i !== groupId)
        : selectedGroups.concat([groupId])
    })
  }

  componentWillReceiveProps(nextProps) {
    const {
      courseBuilder: { courseStartDate, courseExpDate }
    } = this.props
    const {
      courseBuilder: {
        courseStartDate: nextStartDate,
        courseExpDate: nextExpDate
      }
    } = nextProps

    if (!courseStartDate && nextStartDate) {
      this.setState({ startValue: moment(nextStartDate) })
    }

    if (!courseExpDate && nextExpDate) {
      this.setState({ endValue: moment(nextExpDate) })
    }
  }

  handleSelectedAllOrganizations = id => {
    const { list } = this.props
    const { selectedGroups } = this.state

    const { groups = [] } = list.find(i => i.id === id)
    const groupIds = groups.map(i => i.id)

    const selectedOrgGroups = groupIds.filter(i => selectedGroups.includes(i))

    if (groupIds.length === selectedOrgGroups.length) {
      this.setState({
        selectedGroups: selectedGroups.filter(
          i => !selectedOrgGroups.includes(i)
        )
      })
    } else {
      this.setState({
        selectedGroups: selectedGroups
          .filter(i => !groupIds.includes(i))
          .concat(groupIds)
      })
    }
  }

  handleChangeTerms = () => {
    const { isPublish } = this.state
    if (!isPublish) {
      this.setState(state => ({
        checkedTerms: !state.checkedTerms,
        isDisable: !state.isDisable
      }))
    }
  }

  checkedPublishButtonDisabling = () => {
    this.setState({
      isDisable: true,
      isPublish: true
    })
  }

  handleInsertUsers = value => {
    const emails = value.replace(/(\r\n|\n|\r)/gm, ',').split(',')
    const check = _.map(_.compact(emails), email =>
      /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email.trim())
    )
    const isSetValid = _.filter(check, item => item)
    if (isSetValid.length === check.length) {
      this.setState({
        emails: value
          .trim()
          .split('\n')
          .filter(i => !!i),
        isEmailsValid: true
      })
    } else {
      this.setState({
        emails: value
          .trim()
          .split('\n')
          .filter(i => !!i),
        isEmailsValid: false
      })
    }
  }

  onSendEmail = () => {
    this.setState(state => ({
      isSendMail: !state.isSendMail
    }))
  }

  handleCheckUser = () => {
    this.setState({
      isSaving: true
    })
    const { emails } = this.state
    if (!_.isEmpty(emails)) {
      if (this.state.isEmailsValid) {
        const removedSpaceEmail = _.map(emails, email => email.trim())
        const myJSON = JSON.stringify(removedSpaceEmail)
        const {
          user: {
            info: { active_organization_id: activeOrganization }
          }
        } = this.props
        api.events
          .checkUser(myJSON)
          .then(response => {
            const { data } = response
            const isNotExist = data.filter(email => !email.is_exist)
            const isNotInOrg = data.filter(
              email => email.is_exist && !email.in_organization
            )
            this.checkPersonalSpace(activeOrganization, isNotExist, isNotInOrg)
          })
          .catch(error => {
            const { t } = this.props
            message.error(t('emails_validation_error'))
          })
      } else {
        const { t } = this.props
        message.error(t('emails_validation_error'))
      }
    } else {
      this.handlePublish()
    }
  }
  checkPersonalSpace = (activeOrganization, isNotExist, isNotInOrg) => {
    if (activeOrganization) {
      if (_.isEmpty(isNotExist) && _.isEmpty(isNotInOrg)) {
        this.handlePublish()
      } else {
        this.setState({
          isCheckModal: true,
          isNotExist,
          isNotInOrg,
          isLoading: false
        })
      }
    } else {
      if (_.isEmpty(isNotExist)) {
        this.handlePublish()
      } else {
        this.setState({
          isCheckModal: true,
          isNotExist,
          isNotInOrg: [],
          isLoading: false
        })
      }
    }
  }

  handleSendEmail = () => {
    this.handlePublish()
    this.setState({
      isCheckModal: false,
      isNotExist: [],
      isNotInOrg: []
    })
  }

  closeCheckModal = () => {
    const inputHost = document.getElementById('emails')
    if (inputHost) {
      inputHost.focus()
    }
    this.setState({
      isCheckModal: false
    })
  }

  onAdminOnly = () => {
    this.setState(state => ({
      isAdminOnly: !state.isAdminOnly
    }))
  }

  render() {
    const {
      list,
      isFetching,
      user: {
        info: { isAdmin, isSuperAdmin, id, stripe_connect }
      },
      courses: {
        courseById: {
          isFetching: isItemFetching,
          item: { host_ids = [] }
        }
      },
      courseBuilder: {
        courseTitle,
        courseDescription,
        courseCategory,
        courseMarketPlaceDescription,
        courseObjectives,
        coursePrice,
        courseVideoLink,
        coursePassScore,
        courseType
      },
      rootPath,
      t
    } = this.props
    const {
      selectedType,
      selectedOrganizations,
      selectedGroups,
      startValue,
      endValue,
      checkedTerms,
      emails,
      isDisable,
      isAdminOnly,
      isSendMail,
      isCheckModal,
      isNotExist,
      isNotInOrg,
      isPublishing,
      is_mandatory,
      is_retried,
      is_recurrence,
      mandatory_reminder,
      quiz_retried_reminder,
      recurrence_reminder
    } = this.state

    const userCanEditCourse = host_ids.find(item => item === id)

    const privacyTypes = [
      isSuperAdmin && {
        id: 1,
        name: t('v4:public'),
        description: 'PublicDescription'
      },
      (isSuperAdmin || isAdmin || userCanEditCourse) && {
        id: 2,
        name: t('v5:organisations'),
        description: 'OrganisationsDescription'
      },
      (isSuperAdmin || isAdmin || userCanEditCourse) && {
        id: 3,
        name: t('v5:org_groups'),
        description: 'OrganisationGroupsDescription'
      },
      {
        id: 4,
        name: t('v4:specific_user'),
        description: 'SpecificUserDescription'
      },
      {
        id: 5,
        name: t('v5:marketplace'),
        description: 'MarketPlaceDescription',
        disabled: !this.state.enableMarketplace
        // && stripe_connect &&
        // !stripe_connect.status
      }
    ].filter(i => !!i)

    const filteredList = _.isEmpty(list)
      ? []
      : userCanEditCourse
      ? list
      : list.filter(i => isSuperAdmin || (i.role && i.role.name === 'Admin'))

    return (
      <Fragment>
        <section className="section">
          <div className="head head_nopadding">
            <div className="head__title">{t('title')}</div>
            <div className="head__subtitle">{t('course_subtitle')}</div>
          </div>
        </section>

        <section className="section section-publish-setting">
          <Spin spinning={isFetching || isItemFetching}>
            <Page>
              <div style={{ margin: '2.4rem 0' }}>
                <ReminderTriggers
                  onChange={this.handleSelectedDate}
                  startValue={startValue}
                  endValue={endValue}
                  is_mandatory={is_mandatory}
                  is_retried={is_retried}
                  is_recurrence={is_recurrence}
                  mandatory_reminder={mandatory_reminder}
                  quiz_retried_reminder={quiz_retried_reminder}
                  recurrence_reminder={recurrence_reminder}
                />
              </div>
              <div style={{ margin: '2.4rem 0' }}>
                <Description isAdmin={isAdmin} />
              </div>
              <div style={{ margin: '2.4rem 0' }}>
                <PrivacySelector
                  selected={selectedType}
                  types={privacyTypes}
                  isAdmin={isSuperAdmin || isAdmin}
                  onChange={this.handleSelectedType}
                  checkSelectedType={this.checkSelectedType}
                />
              </div>

              {this.checkSelectedType(2) && (
                <div style={{ margin: '2.4rem 0' }}>
                  <OrganizationPicker
                    list={filteredList}
                    selectedOrganizations={selectedOrganizations}
                    onChange={this.handleSelectedOrganizations}
                  />
                </div>
              )}
              {this.checkSelectedType(3) && (
                <div style={{ margin: '2.4rem 0' }}>
                  <GroupPicker
                    list={filteredList}
                    selectedGroups={selectedGroups}
                    onChange={this.handleSelectedGroups}
                    onChangeAll={this.handleSelectedAllOrganizations}
                  />
                </div>
              )}
              {this.checkSelectedType(4) && (
                <div style={{ margin: '2.4rem 0' }}>
                  <Field>
                    <Field.Label>{t('labels:users_emails')}</Field.Label>
                    <Field.Control>
                      <Input.TextArea
                        id="emails"
                        rows={3}
                        onChange={e => this.handleInsertUsers(e.target.value)}
                        defaultValue={emails.join('\n')}
                      />
                    </Field.Control>
                    <span>{t('labels:description_specifiction_email')}</span>
                  </Field>
                </div>
              )}
              {this.checkSelectedType(5) && (
                <div className="workshop_marketplace_section">
                  <div className="workshop_marketplace_section_top">
                    <div className="workshop_marketplace_section_left">
                      <Col md={23}>
                        <Form.Item
                          colon={false}
                          required={false}
                          label={t('labels:title').toUpperCase()}
                        >
                          <Input
                            size="large"
                            value={courseTitle}
                            maxLength={100}
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col md={23}>
                        <Form.Item
                          colon={false}
                          required={false}
                          label={t('v2:price').toUpperCase()}
                        >
                          <Input size="large" disabled value={coursePrice} />
                        </Form.Item>
                      </Col>
                    </div>
                    <div className="workshop_marketplace_section_col">
                      <Col md={23}>
                        <Form.Item
                          colon={false}
                          required={false}
                          label={t('v2:pass_score').toUpperCase()}
                        >
                          <Input
                            size="large"
                            disabled
                            value={coursePassScore}
                          />
                        </Form.Item>
                      </Col>
                      <Col md={23}>
                        <Form.Item
                          colon={false}
                          required={false}
                          label={t('v2:video_link').toUpperCase()}
                        >
                          <Input
                            size="large"
                            maxLength={100}
                            disabled
                            value={courseVideoLink}
                          />
                        </Form.Item>
                      </Col>
                    </div>
                    <div className="workshop_marketplace_section_col_right">
                      <Col md={23}>
                        <Form.Item
                          colon={false}
                          required={false}
                          label={t('general:type').toUpperCase()}
                        >
                          <Input
                            size="large"
                            maxLength={100}
                            disabled
                            value={courseType}
                          />
                        </Form.Item>
                      </Col>
                      <Col md={23}>
                        <Form.Item
                          colon={false}
                          required={false}
                          label={t('v2:category').toUpperCase()}
                        >
                          <Input
                            size="large"
                            maxLength={100}
                            disabled
                            value={courseCategory}
                          />
                        </Form.Item>
                      </Col>
                    </div>
                  </div>
                  <div className="workshop_marketplace_section_bottom">
                    <Col md={24}>
                      <Form.Item
                        label={t('labels:description').toUpperCase()}
                        colon={false}
                        required={false}
                      >
                        <Input.TextArea
                          placeholder={t('v4:text')}
                          autoSize={{ minRows: 5, maxRows: 12 }}
                          disabled
                          style={{ fontSize: '1.6rem', resize: 'none' }}
                          wrap={'soft'}
                          value={courseDescription}
                        />
                      </Form.Item>
                    </Col>
                    <Col md={24}>
                      <Form.Item
                        label={t('v2:objectives').toUpperCase()}
                        colon={false}
                        required={false}
                      >
                        <Input.TextArea
                          placeholder={t('v4:text')}
                          autoSize={{ minRows: 5, maxRows: 12 }}
                          disabled
                          style={{ fontSize: '1.6rem', resize: 'none' }}
                          wrap={'soft'}
                          value={courseObjectives}
                        />
                      </Form.Item>
                    </Col>
                    <Col md={24}>
                      <Form.Item
                        label={t('v2:marketplace_description').toUpperCase()}
                        colon={false}
                        required={false}
                      >
                        <Input.TextArea
                          placeholder={t('v4:text')}
                          autoSize={{ minRows: 5, maxRows: 12 }}
                          disabled
                          style={{ fontSize: '1.6rem', resize: 'none' }}
                          wrap={'soft'}
                          value={courseMarketPlaceDescription}
                        />
                      </Form.Item>
                    </Col>
                  </div>
                </div>
              )}

              {/* <div className="course-setting-publish">
                <div className="course-setting-left">
                  <Page.Field>
                    <DatePicker
                      onChange={this.handleSelectedDate}
                      startValue={startValue}
                      endValue={endValue}
                    />
                  </Page.Field>
                  <Description isAdmin={isAdmin} />
                </div>

                <div className="course-setting-right">
                  <Page.Field>
                    <PrivacySelector
                      selected={selectedType}
                      types={privacyTypes}
                      isAdmin={isSuperAdmin || isAdmin}
                      onChange={this.handleSelectedType}
                      checkSelectedType={this.checkSelectedType}
                    />
                  </Page.Field>
                  {this.checkSelectedType(2) && (
                    <Page.Field>
                      <OrganizationPicker
                        list={filteredList}
                        selectedOrganizations={selectedOrganizations}
                        onChange={this.handleSelectedOrganizations}
                      />
                    </Page.Field>
                  )}

                  {this.checkSelectedType(3) && (
                    <Page.Field>
                      <GroupPicker
                        list={filteredList}
                        selectedGroups={selectedGroups}
                        onChange={this.handleSelectedGroups}
                        onChangeAll={this.handleSelectedAllOrganizations}
                      />
                    </Page.Field>
                  )}
                  {this.checkSelectedType(4) && (
                    <Page.Field>
                      <Field>
                        <Field.Label>{t('labels:users_emails')}</Field.Label>
                        <Field.Control>
                          <Input.TextArea
                            id="emails"
                            rows={3}
                            onChange={e =>
                              this.handleInsertUsers(e.target.value)
                            }
                            defaultValue={emails.join('\n')}
                          />
                        </Field.Control>
                        <span>
                          {t('labels:description_specifiction_email')}
                        </span>
                      </Field>
                    </Page.Field>
                  )}
                  {this.checkSelectedType(5) && (
                    <div className="workshop_marketplace_section">
                      <div className="workshop_marketplace_section_top">
                        <div className="workshop_marketplace_section_left">
                          <Col md={23}>
                            <Form.Item
                              colon={false}
                              required={false}
                              label={t('labels:title').toUpperCase()}
                            >
                              <Input
                                size="large"
                                value={courseTitle}
                                maxLength={100}
                                disabled
                              />
                            </Form.Item>
                          </Col>
                          <Col md={23}>
                            <Form.Item
                              colon={false}
                              required={false}
                              label={t('v2:price').toUpperCase()}
                            >
                              <Input
                                size="large"
                                disabled
                                value={coursePrice}
                              />
                            </Form.Item>
                          </Col>
                        </div>
                        <div className="workshop_marketplace_section_col">
                          <Col md={23}>
                            <Form.Item
                              colon={false}
                              required={false}
                              label={t('v2:pass_score').toUpperCase()}
                            >
                              <Input
                                size="large"
                                disabled
                                value={coursePassScore}
                              />
                            </Form.Item>
                          </Col>
                          <Col md={23}>
                            <Form.Item
                              colon={false}
                              required={false}
                              label={t('v2:video_link').toUpperCase()}
                            >
                              <Input
                                size="large"
                                maxLength={100}
                                disabled
                                value={courseVideoLink}
                              />
                            </Form.Item>
                          </Col>
                        </div>
                        <div className="workshop_marketplace_section_col_right">
                          <Col md={23}>
                            <Form.Item
                              colon={false}
                              required={false}
                              label={t('general:type').toUpperCase()}
                            >
                              <Input
                                size="large"
                                maxLength={100}
                                disabled
                                value={courseType}
                              />
                            </Form.Item>
                          </Col>
                          <Col md={23}>
                            <Form.Item
                              colon={false}
                              required={false}
                              label={t('v2:category').toUpperCase()}
                            >
                              <Input
                                size="large"
                                maxLength={100}
                                disabled
                                value={courseCategory}
                              />
                            </Form.Item>
                          </Col>
                        </div>
                      </div>
                      <div className="workshop_marketplace_section_bottom">
                        <Col md={24}>
                          <Form.Item
                            label={t('labels:description').toUpperCase()}
                            colon={false}
                            required={false}
                          >
                            <Input.TextArea
                              placeholder={t('v4:text')}
                              autoSize={{ minRows: 5, maxRows: 12 }}
                              disabled
                              style={{ fontSize: '1.6rem', resize: 'none' }}
                              wrap={'soft'}
                              value={courseDescription}
                            />
                          </Form.Item>
                        </Col>
                        <Col md={24}>
                          <Form.Item
                            label={t('v2:objectives').toUpperCase()}
                            colon={false}
                            required={false}
                          >
                            <Input.TextArea
                              placeholder={t('v4:text')}
                              autoSize={{ minRows: 5, maxRows: 12 }}
                              disabled
                              style={{ fontSize: '1.6rem', resize: 'none' }}
                              wrap={'soft'}
                              value={courseObjectives}
                            />
                          </Form.Item>
                        </Col>
                        <Col md={24}>
                          <Form.Item
                            label={t(
                              'v2:marketplace_description'
                            ).toUpperCase()}
                            colon={false}
                            required={false}
                          >
                            <Input.TextArea
                              placeholder={t('v4:text')}
                              autoSize={{ minRows: 5, maxRows: 12 }}
                              disabled
                              style={{ fontSize: '1.6rem', resize: 'none' }}
                              wrap={'soft'}
                              value={courseMarketPlaceDescription}
                            />
                          </Form.Item>
                        </Col>
                      </div>
                    </div>
                  )}
                </div>
              </div> */}

              {selectedType.some(item => item > 0) && (
                <div className="disclaimer-wrap">
                  <Page.Field>
                    <Field>
                      <Field.Label>{t('labels:disclaimer')}</Field.Label>
                      <Field.Control>
                        <Input.TextArea
                          disabled
                          rows={6}
                          style={{ resize: 'none' }}
                          value={t('course:disclaimer')}
                        />
                      </Field.Control>
                    </Field>
                    <Field>
                      <Field.Label>
                        <Checkbox
                          value={checkedTerms}
                          onChange={this.handleChangeTerms}
                        >
                          <Trans i18nKey="labels:terms">
                            {t('i_agree_to_these')}
                            <a href="/pages/terms-conditions" target="_blank">
                              {t('terms_and_conditions')}
                            </a>
                          </Trans>
                        </Checkbox>
                      </Field.Label>
                    </Field>
                  </Page.Field>
                </div>
              )}
            </Page>
          </Spin>
        </section>
        {isCheckModal && (
          <Modal
            visible={isCheckModal}
            centered
            title={
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <ReactSVG src="/images/icons/menu/bells.svg" />
                <div style={{ paddingLeft: '2rem' }}>
                  {t('labels:check_user')}
                </div>
              </div>
            }
            onCancel={this.closeCheckModal}
            footer={[
              <Button key="back" shape="round" onClick={this.closeCheckModal}>
                No
              </Button>,
              <Button
                key="submit"
                shape="round"
                type="primary"
                onClick={this.handleSendEmail}
              >
                Yes
              </Button>
            ]}
          >
            {!_.isEmpty(isNotExist) && (
              <div style={{ marginBottom: '1rem' }}>
                <p style={{ color: '#333333' }}>{t('labels:user_not_exist')}</p>
                <div
                  style={{
                    backgroundColor: '#f1f1f1',
                    borderRadius: '.5rem',
                    padding: '1rem'
                  }}
                >
                  {!_.isEmpty(isNotExist) &&
                    isNotExist.map((item, index) => (
                      <div className="selectedMedia">
                        <div className="titleMedia">
                          {index + 1}. {item.email}
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            )}
            {!_.isEmpty(isNotInOrg) && (
              <div>
                <p style={{ color: '#333333' }}>
                  {t('labels:user_not_exist_in_org')}
                </p>
                <div
                  style={{
                    backgroundColor: '#f1f1f1',
                    borderRadius: '.5rem',
                    padding: '1rem'
                  }}
                >
                  {!_.isEmpty(isNotInOrg) &&
                    isNotInOrg.map((item, index) => (
                      <div className="selectedMedia">
                        <div className="titleMedia">
                          {index + 1}. {item.email}
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            )}
          </Modal>
        )}
        <Page.Footer>
          <div className="p-footer">
            <div className="p-footer__inner">
              {this.checkSelectedType(1) && (
                <div className="p-footer__item1">
                  <Checkbox onChange={this.onAdminOnly} checked={isAdminOnly}>
                    {t('v4:admin_only')}
                  </Checkbox>
                </div>
              )}
              {(this.checkSelectedType(2) || this.checkSelectedType(3)) && (
                <div className="p-footer__item1">
                  <Checkbox onChange={this.onSendEmail} checked={isSendMail}>
                    {t('v4:send_email')}
                  </Checkbox>
                </div>
              )}

              <div className="p-footer__item">
                <Button
                  className="rounded"
                  size="large"
                  onClick={() => history.push(`${rootPath}`)}
                >
                  {t('buttons:back_to_course')}
                </Button>
              </div>
              <div className="p-footer__item">
                <Button
                  className="rounded"
                  size="large"
                  type="green"
                  onClick={this.handleCheckUser}
                  disabled={isDisable}
                  loading={isPublishing}
                >
                  {t('buttons:publish_course')}
                </Button>
              </div>
            </div>
          </div>
        </Page.Footer>
      </Fragment>
    )
  }
}

export default withTranslation('publishsettings')(PublishSettings)
